/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { TransformedStructure } from './fieldsModalTypes';
import { normalizeSearch } from '../../../utils/stringUtils';

export const sortStructure = (structure: TransformedStructure[]) =>
 structure.slice().sort((obj1, obj2) => {
  if (
   ['model', 'array'].includes(obj1.Type) &&
   !['model', 'array'].includes(obj2.Type)
  ) {
   return -1; // obj1 comes before obj2
  }
  if (
   !['model', 'array'].includes(obj1.Type) &&
   ['model', 'array'].includes(obj2.Type)
  ) {
   return 1; // obj2 comes before obj1
  }
  return 0; // maintain relative order otherwise
 });

export const filterStructureForSearch = (
 root: TransformedStructure[],
 selected: TransformedStructure[],
 text: string,
): TransformedStructure[] =>
 root.reduce((acc: TransformedStructure[], item: TransformedStructure) => {
  const normalizedText = normalizeSearch(text);
  const normalizedTranslation = normalizeSearch(item.Translation || '');
  if (
   normalizedTranslation.includes(normalizedText) ||
   (item.InnerStructure &&
    filterStructureForSearch(item.InnerStructure, selected, text).length > 0)
  ) {
   acc.push({
    ...item,
    isSelected: selected.some((selectedItem) => selectedItem.Key === item.Key),
    InnerStructure: item.InnerStructure
     ? filterStructureForSearch(item.InnerStructure, selected, text)
     : [],
   });
  }
  return acc;
 }, []);

export const filterStructureForExpanded = (
 data: TransformedStructure[],
 depth = 1,
): string[] => {
 let result: string[] = [];
 for (const item of data) {
  const depthKey = `${depth}_${item.Name}`;
  if (['model', 'array'].includes(item.Type)) {
   result.push(depthKey);
  }
  if (Array.isArray(item.InnerStructure) && item.InnerStructure.length > 0) {
   result = result.concat(
    filterStructureForExpanded(item.InnerStructure, depth + 1),
   );
  }
 }
 return result;
};
